// @ts-expect-error no declarations found for module
import { getSections } from 'EmailEditorUI/redux/selectors/sectionSelectors';
import useIsSectionBoxed from 'EmailEditorUI/hooks/styleSettings/useIsSectionBoxed';
import useSectionBreakpointStyles from 'EmailEditorUI/hooks/styleSettings/useSectionBreakpointStyles';
import { useAppSelector } from 'EmailEditorUI/redux';
function useIsLayoutPaddingDisabled(side) {
  const section = useAppSelector(state => side === 'top' ? getSections(state).first() : getSections(state).last());
  const {
    backgroundType
  } = useSectionBreakpointStyles(section);
  const isSectionBoxed = useIsSectionBoxed(section);
  return !isSectionBoxed && backgroundType === 'FULL';
}
export default useIsLayoutPaddingDisabled;